import { Truck, ShoppingBag, BadgePercent } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal, Overline } from "./Reveal";
import { useOrder } from "./OrderDialog";
import { useLang } from "../i18n";

export const OrderSection = () => {
    const order = useOrder();
    const { t } = useLang();
    return (
        <section id="order" data-testid="order-online-section" className="relative py-24 sm:py-32 overflow-hidden">
            <div
                className="absolute inset-0 opacity-[0.35]"
                style={{
                    background:
                        "radial-gradient(ellipse 60% 50% at 50% 40%, rgba(217,119,6,0.12), transparent 70%)",
                }}
                aria-hidden="true"
            />
            <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
                <Reveal>
                    <Overline className="justify-center">{t("order.overline")}</Overline>
                    <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
                        {t("order.h1a")} <span className="italic gold-text">{t("order.h1b")}</span>
                    </h2>
                    <p className="mt-5 text-stone-400 font-light max-w-lg mx-auto">
                        {t("order.sub")}
                    </p>
                </Reveal>

                <div className="mt-12 grid sm:grid-cols-2 gap-5 max-w-2xl mx-auto">
                    {[
                        { icon: Truck, title: t("order.delT"), sub: t("order.delS"), testId: "order-delivery-card", soon: true },
                        { icon: ShoppingBag, title: t("order.pickT"), sub: t("order.pickS"), testId: "order-pickup-card" },
                    ].map((c, i) => (
                        <Reveal key={c.title} delay={0.1 * i}>
                            <button
                                data-testid={c.testId}
                                onClick={() => order?.openOrder()}
                                className="group relative w-full gold-border rounded-2xl bg-elevated/60 p-8 hover:border-saffron/50 hover:bg-elevated transition-[border-color,background-color] duration-500 text-center"
                            >
                                {c.soon && (
                                    <span className="absolute top-4 right-4 rounded-full bg-saffron/15 border border-saffron/40 px-2.5 py-1 text-[9px] font-bold tracking-[0.12em] uppercase text-saffron-glow">
                                        {t("notice.soon")}
                                    </span>
                                )}
                                <c.icon
                                    className="w-8 h-8 mx-auto text-saffron-bright transition-transform duration-500 group-hover:-translate-y-1"
                                    strokeWidth={1.25}
                                />
                                <p className="mt-4 font-serif text-3xl text-cream">{c.title}</p>
                                <p className="mt-1 text-sm text-stone-400 font-light">{c.sub}</p>
                                <span className="mt-5 inline-block text-xs tracking-[0.2em] uppercase text-brass group-hover:text-saffron-glow transition-colors duration-300">
                                    {t("order.callPrefix")} {SITE.phoneDisplay}
                                </span>
                            </button>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <div
                            data-testid="promo-first-order"
                            className="flex items-center gap-3 rounded-full gold-border bg-saffron/10 px-6 py-3"
                        >
                            <BadgePercent className="w-5 h-5 text-saffron-glow shrink-0" strokeWidth={1.5} />
                            <p className="text-xs sm:text-sm text-cream">
                                <span className="font-semibold text-saffron-glow">{t("order.promo1a")}</span>{" "}
                                {t("order.promo1b")}
                            </p>
                        </div>
                        <div
                            data-testid="promo-free-delivery"
                            className="flex items-center gap-3 rounded-full gold-border bg-saffron/10 px-6 py-3"
                        >
                            <Truck className="w-5 h-5 text-saffron-glow shrink-0" strokeWidth={1.5} />
                            <p className="text-xs sm:text-sm text-cream">
                                <span className="font-semibold text-saffron-glow">{t("order.promo2a")}</span>{" "}
                                {t("order.promo2b")}
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
